import React from 'react';

export function MenuSection({
  onAppSectionChange,
  setMainMenuOpen,
  setSystemSubmenuOpen
}) {
  return (
              <div className="quick-links-section">
                <div className="quick-links-title">Schnellzugriff</div>

                {/* Dashboard Link (In-App) */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('dashboard');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M3 13h8V3H3v10z" />
                      <path d="M13 21h8V11h-8v10z" />
                      <path d="M13 3h8v6h-8V3z" />
                      <path d="M3 17h8v4H3v-4z" />
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Dashboard</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}
                
                {/* Tarife Link */}
                {onAppSectionChange ? (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('cards');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="2" y="5" width="20" height="14" rx="3" />
                      <path d="M2 10h20" />
                      <circle cx="17" cy="15" r="2" />
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Tarife</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                ) : (
                  <a href="tarifcards.html" className="menu-item" onClick={() => setMainMenuOpen(false)}>
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="2" y="5" width="20" height="14" rx="3" />
                      <path d="M2 10h20" />
                      <circle cx="17" cy="15" r="2" />
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Tarifübersicht öffnen</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </a>
                )}

                {/* Druckansicht Link */}
                <a href="druckansicht.html" className="menu-item" onClick={() => setMainMenuOpen(false)}>
                  <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M6 9V2h12v7" />
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                    <rect x="6" y="14" width="12" height="8" />
                  </svg>
                  <div className="menu-item-content">
                    <span className="menu-item-title">Druckansicht</span>
                  </div>
                  <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </a>

                {/* Spielgeldrechner Link (In-App) */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('spielgeld');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="4" y="2" width="16" height="20" rx="2" />
                      <line x1="8" y1="6" x2="16" y2="6" />
                      <line x1="8" y1="10" x2="8" y2="10.01" />
                      <line x1="12" y1="10" x2="12" y2="10.01" />
                      <line x1="16" y1="10" x2="16" y2="10.01" />
                      <line x1="8" y1="14" x2="16" y2="14" />
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Spielgeldrechner</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* Angebot / Konfigurator */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('konfigurator');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                      <line x1="16" y1="13" x2="8" y2="13"/>
                      <line x1="16" y1="17" x2="8" y2="17"/>
                      <polyline points="10 9 9 9 8 9"/>
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Angebot konfigurieren</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* Smartphones */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('smartphones');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="5" y="2" width="14" height="20" rx="2"/>
                      <line x1="12" y1="18" x2="12.01" y2="18"/>
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Angebot Smartphones</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* Router */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('router');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <rect x="2" y="14" width="20" height="6" rx="2"/>
                      <path d="M6 14V9a6 6 0 0 1 12 0v5"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Angebot Router / Hardware</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* Abschluss */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('abschluss');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                      <polyline points="22 4 12 14.01 9 11.01"/>
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Tagesabschluss / Reports</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* WKZ */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('wkz');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <line x1="12" y1="1" x2="12" y2="23"/>
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">WKZ Rechner</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* Flyer */}
                {onAppSectionChange && (
                  <button
                    type="button"
                    className="menu-item"
                    onClick={() => {
                      onAppSectionChange('flyer');
                      setMainMenuOpen(false);
                      setSystemSubmenuOpen(false);
                    }}
                  >
                    <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                    </svg>
                    <div className="menu-item-content">
                      <span className="menu-item-title">Flyer & Vorlagen</span>
                    </div>
                    <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </button>
                )}

                {/* System Link */}
                <button 
                  className="menu-item"
                  onClick={() => setSystemSubmenuOpen(true)}
                >
                  <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <circle cx="12" cy="12" r="3" />
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                  </svg>
                  <div className="menu-item-content">
                    <span className="menu-item-title">System-Einstellungen</span>
                  </div>
                  <svg className="menu-item-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </button>

                {/* Abmelden (Logout) */}
                <button 
                  className="menu-item"
                  onClick={() => {
                    localStorage.removeItem('tef_jwt');
                    localStorage.removeItem('tef_user');
                    localStorage.removeItem('tef_role');
                    window.location.href = '/login';
                  }}
                  style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.08)' }}
                >
                  <svg className="menu-item-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  <div className="menu-item-content">
                    <span className="menu-item-title" style={{ color: '#ff7070' }}>Abmelden</span>
                  </div>
                </button>
              </div>
  );
}